
import { resourcesAR } from "./SharedResources.ar"

export const resources = {
    en: {
        Home: "Home",
        Services: "Services",
        Contact: "Contact",
        About: "About",
        Submit: "Submit",
        SocialMedia: "Social Media",
        CreatedBY: "Created By",
        Main: "Main",
        Industries: "Industries"

    },
    ar: resourcesAR
}


export const dropdownIds = {
    about: {
        overview: "overview",
        mission: "mission",
        whoWeAre: "who-we-are",
        approach: "approach",
    },
    services: {
        BPO: "BPO",
        FPA: "FPA",
        CFO: "CFO",
    },
    industries: {
        pharma: "pharmaceuticals",
        tech: "technology",
        manufacturing: "manufacturing",
        retail: "retail",
        professional: "professional",
        healthcare: "healthcare",
    },
};


export const dropdownOptions = {
    en: {
        about: [
            { id: dropdownIds.about.overview, label: "Overview" },
            { id: dropdownIds.about.mission, label: "Mission & Vision" },
            { id: dropdownIds.about.whoWeAre, label: "Who We Are" },
            { id: dropdownIds.about.approach, label: "Our Approach" },
        ],
        services: [
            { id: dropdownIds.services.BPO, label: "Financial BPO Services" },
            { id: dropdownIds.services.FPA, label: "FP&A Outsourcing" },
            { id: dropdownIds.services.CFO, label: "Fractional CFO Services" },
        ],
        industries: [
            { id: dropdownIds.industries.pharma, label: "Pharmaceuticals & Life Sciences" },
            { id: dropdownIds.industries.tech, label: "Technology & SaaS" },
            { id: dropdownIds.industries.manufacturing, label: "Manufacturing" },
            { id: dropdownIds.industries.retail, label: "Retail & E-commerce" },
            { id: dropdownIds.industries.professional, label: "Professional Services" },
            { id: dropdownIds.industries.healthcare, label: "Healthcare" },
        ],
    },
    ar: {
        about: [
            { id: dropdownIds.about.overview, label: "نظرة عامة" },
            { id: dropdownIds.about.mission, label: "الرسالة والرؤية" },
            { id: dropdownIds.about.whoWeAre, label: "من نحن" },
            { id: dropdownIds.about.approach, label: "نهجنا" },
        ],
        services: [
            { id: dropdownIds.services.BPO, label: "خدمات التعهيد المالي" },
            { id: dropdownIds.services.FPA, label: "خدمات FP&A" },
            { id: dropdownIds.services.CFO, label: "خدمات المدير المالي الجزئي" },
        ],
        industries: [
            { id: dropdownIds.industries.pharma, label: "الأدوية وعلوم الحياة" },
            { id: dropdownIds.industries.tech, label: "التكنولوجيا و SaaS" },
            { id: dropdownIds.industries.manufacturing, label: "التصنيع" },
            { id: dropdownIds.industries.retail, label: "التجزئة والتجارة الإلكترونية" },
            { id: dropdownIds.industries.professional, label: "الخدمات المهنية" },
            { id: dropdownIds.industries.healthcare, label: "الرعاية الصحية" },
        ],
    },
};
